module.exports = __webpack_public_path__ + "static/media/door-24.d75429ab.svg";